<template>
    <ShipmentForm :url="url" :model="model" :errors="errors" v-on:save="saveShipment"></ShipmentForm>
</template>

<script>
import ShipmentForm from './ShipmentForm'
export default {
  name: 'ShipmentEdit',
  components: {ShipmentForm},
  props: ['url'],
  data () {
    return {
      model: {},
      errors: {}
    }
  },
  methods: {
    saveShipment () {
      let self = this

      this.$http
        .put(this.url + `/update/${this.$route.params.id}`, this.model, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.model = res.data.data
            this.$router.push('/admin/shipments/index')
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Shipment Edit'))

    let self = this
    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.model = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/shipment/ShipmentEdit.vue